
import React from 'react';
import EventForm from './EventForm';
import './App.css';

function App() {
  return (
    <div className="App">
      <h1>Event Registration Form</h1>
      <div className='event-form'><EventForm /></div>
    </div>
  );
}

export default App;
